// extracted by css-extract-rspack-plugin
export default {"transition":"_befd795a"};